<template>
  <div>
    <div ref="chartContainer" class="pa-3" style="width:96%; height:90%"></div>
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';

Exporting(Highcharts);
ExportData(Highcharts);

Highcharts.wrap(Highcharts.Series.prototype, 'setVisible', function (proceed, vis, redraw, animation) {
  if (this.chart.options.customDisableLegendToggle) {
    return this;
  }
  return proceed.call(this, vis, redraw, animation);
});

export default {
  name: 'BarForBatchSearch',
  props: ["tdata"],
  data(){
    return {
      chart: null
    }
  },
  computed: {
    textEvidenceColor() {
      return this.$store.state.textEvidenceColor;
    },
    figureEvidenceColor() {
      return this.$store.state.figureEvidenceColor;
    },
    experimentEvidenceColor() {
      return this.$store.state.experimentEvidenceColor;
    },
    cohortEvidenceColor() {
      return this.$store.state.cohortEvidenceColor;
    },
    colorMap() {
      return {
        text_evidence_count: this.textEvidenceColor,
        figure_evidence_count: this.figureEvidenceColor,
        experiment_evidence_count: this.experimentEvidenceColor,
        cohort_evidence_count: this.cohortEvidenceColor
      };
    },
    nameMap() {
      return {
        text_evidence_count: 'Text mining',
        figure_evidence_count: 'Figure mining',
        experiment_evidence_count: 'PTMAtlas datasets',
        cohort_evidence_count: 'CPTAC datasets'
      };
    }
  },
  methods: {
    renderChart() {
      if (!this.tdata || this.tdata.length === 0) return;
      const container = this.$refs.chartContainer;
      if (!container) return;

      const categories = this.tdata.map(item => {
        const id = item.internal_id || '';
        const parts = id.split('_');
        return parts.length >= 2 ? `${parts[0]}:${parts[1]}` : id;
      });

      const allFields = ['text_evidence_count', 'figure_evidence_count', 'experiment_evidence_count', 'cohort_evidence_count'];
      const includedFields = allFields.filter(field => field in this.tdata[0]);

      const series = includedFields.map(field => {
        return {
          name: this.nameMap[field],
          data: this.tdata.map(item => ({
            y: item[field] || 0,
            id: item.internal_id
          })),
          color: this.colorMap[field],
          showInLegend: true,
          enableMouseTracking: true
        };
      });

      if (this.chart) {
        this.chart.destroy();
      }
      this.chart =Highcharts.chart(container, {
        chart: {
          type: 'column',
          zoomType: 'y',
          spacingTop: 20,
          spacingRight: 10,
          spacingBottom: 10,
          spacingLeft: 10
        },
        customDisableLegendToggle: true,

        title: { text: '' },
        xAxis: {
          categories,
          crosshair: true,
          title: { text: 'Site' },
          labels: { rotation: -45, step: 1 }
        },
        yAxis: {
          title: { text: 'Evidence Count' },
          stackLabels: { enabled: true }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          shadow: false,
          itemStyle: { cursor: 'default' },
          itemHiddenStyle: { opacity: 1 }
        },
        tooltip: {
          formatter: function () {
            return `<b>${this.point.id}</b><br/>
              ${this.series.name}: ${this.y}<br/>
              Total: ${this.point.stackTotal}`;
          },
          distance: 30,
          followPointer: true
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: { enabled: true },
            point: {
              events: {
                click: function () {
                  const base_url = window.location.origin;
                  const itemId = this.options.id;
                  const url = `${base_url}/#/single-search/${itemId}?ptm_type=phosphorylation`;
                  window.open(url, '_blank');
                }
              }
            }
          }
        },
        series,
        exporting: {
          enabled: true,
          sourceWidth: 800,
          sourceHeight: 600,
          scale: 4,
          buttons: {
            contextButton: {
              x: 10,
              y: -28,
              menuItems: ['downloadPNG', 'downloadSVG']
            }
          }
        }
      });
    }
  },
  watch: {
    tdata: {
      handler() {
        this.$nextTick(this.renderChart);
      },
      immediate: true
    }
  }

};
</script>
